import React from 'react'
import { Navigate } from 'react-router-dom'
import { useCapitalActivePayoutsAccess } from '../../../hooks/useCapitalActivePayoutsAccess'

interface StripePayoutsRedirectGuardProps {
	children: React.ReactNode
}

const StripePayoutsRedirectGuard = ({ children }: StripePayoutsRedirectGuardProps): JSX.Element => {
	const { canAccess } = useCapitalActivePayoutsAccess()

	if (canAccess) {
		return <Navigate to="/dashboard/stripe-payouts" replace />
	}

	return <>{children}</>
}

export default StripePayoutsRedirectGuard
